import React, { Component } from "react";
import FieldError from "./FieldError";
import {cx} from "../../lib/ClassSet";
import "./TextInputField.scss";

const noOp = () => null;

class TextInputField extends Component {

  constructor(props) {
    super(props);
    this.handleFocus = this.handleFocus.bind(this);
  }

  render() {
    const {serverError, label, active, maxLength, minLength, type, input: {value, onChange}, meta: {touched, error}} = this.props;    

    let changeHandler = active ? onChange : noOp;
    let classes = cx({
      "TextInput": true,
      "s-inactive": !active
    });

    let extras = {
      type: type,
      maxLength: maxLength,
      minLength: minLength
    }

    if (this.props.table === false) {
      return (
        <div className="TextInputField field">
          <input className={classes} value={value} onChange={changeHandler} onFocus={this.handleFocus} placeholder={this.props.placeholder} {...extras} />
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </div>
      )
    }

    return (
      <tr className="TextInputField field">
        <th>{label} <span className="optionalHelpText">{this.props.help}</span></th>
        <td>
          <input className={classes} value={value} onChange={changeHandler} onFocus={this.handleFocus} placeholder={this.props.placeholder} {...extras} />
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )
  }

  handleFocus(e) {
    e.target.select();
  }
}

TextInputField.defaultProps = {
  active: true,
  placeholder: "",
  maxLength: "none",
  minLength: "none",
  type: "text",
  table: true
}

export default TextInputField;